module.exports = __webpack_public_path__ + "static/media/POLYGON.fd162129.svg";